import ContractAccounts from "./ContractAccounts-container";

/**
 * Export the top level component ContractAccounts-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default ContractAccounts;
